import type { AccountAccessToken } from '@setplex/tria-api'

import { api } from '@setplex/tria-api'
import {
  attach,
  combine,
  createEffect,
  createEvent,
  createStore,
  sample,
} from 'effector'
import { openWindow } from '~/core/router'
import { model as session, model as sessionModel } from '~/entities/session'
import { model as config, remote } from '~/shared/config'
import { getSubscriberAccountSettingsUrl } from './helpers'

export const getPortalAccountAccessTokenFx = attach({
  effect: api.subscriber.getAccountAccessTokenFx,
})

const $remoteSubscriberAccountSettingsURL = config.get(
  remote.tria_subscriberAccountSettingsUrl
)

export const $subscriberAccountSettingsURL = combine(
  $remoteSubscriberAccountSettingsURL,
  sessionModel.$session,
  (remoteSubscriberAccountSettingsURL, session) =>
    session?.shoppingCartUrl || remoteSubscriberAccountSettingsURL
)

export const openAccountSettingsModal = createEvent()
export const closeAccountSettingsModal = createEvent()
export const $isAccountSettingsModalOpened = createStore<boolean>(false)
  .on(openAccountSettingsModal, () => true)
  .on(closeAccountSettingsModal, () => false)

const $accountAccessToken = createStore<AccountAccessToken | null>(null)

const redirectToAccountSettingsFx = createEffect((url: string | null) => {
  if (url) return openWindow(url, 'external_portal', 'noreferrer')
  throw new Error('Empty link')
})

sample({
  clock: openAccountSettingsModal,
  target: getPortalAccountAccessTokenFx,
})

sample({
  clock: getPortalAccountAccessTokenFx.doneData,
  target: $accountAccessToken,
})
sample({
  clock: getPortalAccountAccessTokenFx.failData,
  fn: () => null,
  target: $accountAccessToken,
})

export const navigateToAccountSettings = createEvent<void>()

sample({
  clock: navigateToAccountSettings,
  source: {
    token: $accountAccessToken,
    baseUrl: $subscriberAccountSettingsURL,
    session: session.$session,
  },
  fn: ({ baseUrl, session, token }) =>
    getSubscriberAccountSettingsUrl({ baseUrl, session, token }),
  target: redirectToAccountSettingsFx,
})

sample({
  clock: redirectToAccountSettingsFx.doneData,
  target: closeAccountSettingsModal,
})
